<template>
  <v-app class="bckgrnd">
    <v-container fluid grid-list-md text-xs-center>
      <v-card flat style="border-radius:10px;padding-top:5px;padding-bottom:5px;border: 2px solid;border-color:#f99420">
        <v-card-title style="padding:0px">
          <h5>Overview</h5>
          <v-spacer></v-spacer>
        <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important">
                            <avatar :size="32" :username="loggedInUserName"></avatar>
                           &nbsp;&nbsp;{{loggedInUserName}}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>

              <v-dialog v-model="logOutDialog" max-width="290" persistent>
                <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;">
                  <v-sheet color="transparent" style="text-align:center">
                    <v-icon color="#0d47a1" :size="40">https</v-icon>
                  </v-sheet>
                  
                  <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

                  <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Worldwin ?</v-card-text>

                  
                    <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                </v-card>
              </v-dialog>
        </v-card-title>
      </v-card>

      <v-card flat style="margin-top:15px;background-color:#1976D2">
          <v-layout row wrap>
            <v-flex xs12>
              <h4 style="text-align:center;margin-bottom:0px;color:white;font-weight:bold">FOLLOWUP</h4>
            </v-flex>
            <v-flex xs12 sm2 md2 style="padding-right:5px">
            <v-dialog ref="dialog" v-model="fromDateModel" persistent lazy full-width width="340px">
              <v-text-field
                style="background-color:white;height:55px;border-radius:5px"
                slot="activator"
                v-model="form.fromDate"
                label="From date"
                append-icon="event"
                readonly
                outline
              ></v-text-field>
              <v-date-picker v-model="form.fromDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="fromDateModel = false">OK</v-btn>
              </v-date-picker>
            </v-dialog>
         </v-flex>

         <v-flex xs12 sm2 md2>
            <v-dialog ref="dialog" v-model="toDateModel" persistent lazy full-width width="340px">
              <v-text-field
                style="background-color:white;height:55px;border-radius:5px"
                slot="activator"
                v-model="form.toDate"
                label="To date"
                append-icon="event"
                readonly
                outline
              ></v-text-field>
              <v-date-picker v-model="form.toDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="toDateModel = false">OK</v-btn>
              </v-date-picker>
            </v-dialog>
         </v-flex>
         <v-flex xs12 sm5 md5 style="text-align:right;padding-top:10px">
           <v-btn v-if="refsh==true" :disabled="btnSave1" color="#1b5e20" dark depressed @click="refresh()">Refresh</v-btn>
           <v-btn color="#b71c1c" dark depressed :loading="btnSave" @click="onSubmit()">Submit</v-btn>
         </v-flex>

         <v-flex xs12 sm3 md3>
           <v-text-field
           style="background-color:white;height:55px;border-radius:5px"
           outline
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
         </v-flex>
          </v-layout>
      </v-card>
      <v-card>
        <v-data-table :headers="leadsTableHeader" :items="leads" :search="search" >
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left hvr" @click="onView(props.item)">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.leadDate }}</td>
          <td class="text-xs-left">{{ props.item.source }}</td>
          <td class="text-xs-left">{{ props.item.levelName }}</td>
          <td class="text-xs-left" v-if="props.item.countryList[1]==null&&props.item.countryList[2]==null&&props.item.countryList[3]==null&&props.item.countryList[4]==null">
            {{ props.item.countryList[0]}}</td>
            <td class="text-xs-left" v-if="props.item.countryList[1]!=null&&props.item.countryList[2]==null&&props.item.countryList[3]==null&&props.item.countryList[4]==null">
            {{ props.item.countryList[0]+", "+props.item.countryList[1]}}</td>
            <td class="text-xs-left" v-if="props.item.countryList[1]!=null&&props.item.countryList[2]!=null&&props.item.countryList[3]==null&&props.item.countryList[4]==null">
            {{ props.item.countryList[0]+", "+props.item.countryList[1]+", "+props.item.countryList[2]}}</td>
            <td class="text-xs-left" v-if="props.item.countryList[1]!=null&&props.item.countryList[2]!=null&&props.item.countryList[3]!=null&&props.item.countryList[4]==null">
            {{ props.item.countryList[0]+", "+props.item.countryList[1]+", "+props.item.countryList[2]+", "+props.item.countryList[3]}}</td>
            <td class="text-xs-left" v-if="props.item.countryList[1]!=null&&props.item.countryList[2]!=null&&props.item.countryList[3]!=null&&props.item.countryList[4]!=null">
            {{ props.item.countryList[0]+", "+props.item.countryList[1]+", "+props.item.countryList[2]+", "+props.item.countryList[3]+", "+props.item.countryList[4]}}</td>
          
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>

//import Vue from "vue";
import Avatar from "vue-avatar";
import config from "../../config.json";
import CounsellorDashboard from "../Dashboard/CounsellorDashboard";
export default {
  components: {
    Avatar,
    CounsellorDashboard
  },
  data() {
    return {
      roleType: sessionStorage.roles,
      search: "",
      fromDateModel: false,
      toDateModel: false,
      btnSave: false,
      btnSave1: false,
      refsh: false,

      leads: [],
      leadData:[],
      search: "",
      leadsTableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Full name", value: "name" },
        { text: "Date", value: "leadDate" },
        { text: "Source", value: "source" },
        { text: "Level", value: "levelName" },
        { text: "Suggested Countries", value: "countryList" }
      ],

      form: {
        fromDate: null,
        toDate: null
      },
    
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
    };
  },

  mounted() {
    this.axios
        .get(config.API + "CounsellorDashboard", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.leads = res.data.todayFollowup;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
  },

  methods: {
    onView(item) {
      this.$router.push(`/viewLead/${item.id}`);
    },
    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    onSubmit() {
      this.btnSave = true;
        this.axios
          .post(
            config.API + `CounsellorDashboard`,
            {
              fromDate: new Date(this.form.fromDate),
              toDate: new Date(this.form.toDate)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
          this.leads = res.data;
          this.refsh = true;
          this.btnSave = false;
        });
    },

    refresh() {
      this.btnSave1 = true;
      this.form.fromDate = null;
      this.form.toDate = null;
      this.refsh = false;

      this.axios
        .get(config.API + "CounsellorDashboard", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.leads = res.data.todayFollowup;
          this.btnSave1 = false;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    }
  }
};
</script>

<style scoped>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
</style>
